import { mapActions } from 'vuex'
import { createRouter, checkPermissions } from './router'
import { createStore } from './store'
import { createI18n } from './i18n'

export function createApp({ Vue, Router, Store, I18n }) {
  const router = createRouter({ Vue, Router })
  const store = createStore({ Vue, Store })
  const i18n = createI18n({ Vue, I18n })
  checkPermissions(router)
  const app = new Vue({
    router,
    store,
    i18n,
    created() {
      if (window.isAuthenticated) {
        this.getProfileCommonAPI()
      }
    },
    data() {
      return {
        reviewsSliderOptions: {
          slidesPerView: 3,
          spaceBetween: 114,
          autoHeight: true,
          loop: true,
          navigation: {
            prevEl: '.js-review-prev',
            nextEl: '.js-review-next',
          },
          breakpoints: {
            992: {
              spaceBetween: 40,
              slidesPerView: 2,
            },
            564: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
          }
        },
      }
    },
    methods: {
      ...mapActions('cabinet', [
        'getProfileCommonAPI',
      ]),
    },
  })

  return { app, router, store, i18n }
}



// WEBPACK FOOTER //
// ./src/js/createApp.js